module.exports = __webpack_public_path__ + "static/media/ademindashboard.f0258afd.png";